import { Navigate } from "react-router-dom";

export function PublicRoute({ children }: { children: React.ReactElement }) {
    const token = localStorage.getItem('token');
    const isAuthenticated = !!token;
  
    return isAuthenticated ? <Navigate to="/" /> : children;
  }